// extracted by mini-css-extract-plugin
export default {"UserHeader":"UserHeader_UserHeader__1SLY3","menu-header":"UserHeader_menu-header__7Dvep","menu":"UserHeader_menu__k40au","menu-item":"UserHeader_menu-item__N+Ae4"};